"use client";
import { useModal } from "@/components/modal-context";
import { usePathname, useRouter } from "@/i18n/routing";
import { cn, RadioGroup, RadioProps, useRadio, VisuallyHidden } from "@heroui/react";
import clsx from "clsx";
import { useTranslations } from "next-intl";
import { useParams } from "next/navigation";

function LanguageRadio(props: RadioProps) {
  const { Component, children, getBaseProps, getInputProps } = useRadio(props);

  return (
    <Component
      {...getBaseProps()}
      className={cn(
        "group inline-flex flex-row-reverse items-center justify-between tap-highlight-transparent hover:opacity-70 active:opacity-50",
        "flex aspect-[6/1] h-auto w-full cursor-pointer flex-col items-center justify-center gap-4 rounded-md py-2",
        "border-2 border-[#333] bg-[#333333] data-[selected=true]:border-[#0F7764] data-[selected=true]:bg-[#053335]"
      )}
    >
      <VisuallyHidden>
        <input {...getInputProps()} />
      </VisuallyHidden>
      <div className="flex flex-col items-center justify-center gap-2 text-center">{children}</div>
    </Component>
  );
}

export default function ({ locale }: { locale: string }) {
  const t = useTranslations();
  const { openModal } = useModal();
  const pathname = usePathname();
  const router = useRouter();

  return (
    <button
      className={clsx(
        "aspect-square size-8 sm:size-10 overflow-hidden rounded-full text-[1.5rem] leading-none text-[#E1E1E1] sm:text-[2rem]"
      )}
      onClick={() => {
        openModal(
          <div className="flex size-full h-24 flex-col items-center justify-center text-center">
            <RadioGroup
              aria-label="payment-method"
              className="w-full"
              classNames={{
                wrapper: clsx("grid grid-cols-2 gap-4"),
              }}
              defaultValue={locale}
              onValueChange={(value) =>
              {
                router.push(pathname, { locale: value });
              }}
            >
              <LanguageRadio value="en">
                <div className="text-tiny">
                  <span className="fi fi-gb" /> {t("English")}
                </div>
              </LanguageRadio>
              <LanguageRadio value="bn">
                <div className="text-tiny">
                  <span className="fi fi-bd" /> {t("Bengali")}
                </div>
              </LanguageRadio>
            </RadioGroup>
          </div>,
          t("Language")
        );
      }}
    >
      <span
        className={clsx("fi block text-[2.05rem] sm:text-[2.55rem]",  {
          "fi-gb": locale === "en",
          "fi-bd": locale === "bn",
        })}
      ></span>
    </button>
  );
}
